module.exports = __webpack_public_path__ + "img/kw.0090c3f5.svg";